<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { ContactPersonToContractV1Dto } from '@/openapi';
import { navigationItems } from '@/router/navigation';

import type { PaginatedDataTableCellProps } from './templateTypes';

const { t } = useI18n();

const roleIcon = `mdi mdi-account-tie sey-icon mr-1`;
const contactIcon = `${navigationItems?.find((a) => a.name === 'contactPersons')?.icon} sey-icon mr-1`;

const props = defineProps<PaginatedDataTableCellProps<ContactPersonToContractV1Dto[]>>();
console.log(props.cell);
</script>

<template>
  <ExpandableCell v-if="props.cell?.length" :data-key="dataKey" :field="column.field">
    <!-- Collapsed content -->
    <template #collapsed>
      <div class="space-y-1">
        <div class="flex gap-2">
          <div class="font-semibold truncate"><span :class="roleIcon" />{{ t(`labels.role`) }}</div>
          <div class="flex-1">
            {{ t(`enums.${props.cell?.[0].role?.toUpperCase()}`) }}
            [...]
          </div>
        </div>
      </div>
    </template>

    <!-- Expanded content -->
    <template #expanded>
      <div v-for="(arrayValue, arrayIndex) in props.cell" :key="arrayIndex" class="space-y-1 mb-2">
        <div class="flex gap-2">
          <div class="font-semibold w-32 truncate">
            <span :class="roleIcon" />{{ t(`labels.role`) }}
          </div>
          <div class="flex-1">
            {{ t(`enums.${arrayValue.role?.toUpperCase()}`) }}
          </div>
        </div>
        <div class="flex gap-2">
          <div class="font-semibold w-32 truncate">
            <span :class="contactIcon" />{{ t(`labels.contact`) }}
          </div>
          <div class="flex-1">
            {{ arrayValue.contactPerson?.firstName }} {{ arrayValue.contactPerson?.lastName }}
          </div>
        </div>
      </div>
    </template>
  </ExpandableCell>
</template>
